module.exports = __webpack_public_path__ + "static/media/a18_wba.e4f5775c.png";